<template>
  <el-dialog
    title="修改密码"
    :visible.sync="showDialog"
    width="25%"
    :top="'20vh'"
    :close-on-click-modal="false"
    class="pwdDialog"
  >
    <el-form
      class="pwdDialog__form"
      label-width="110px"
      :model="form"
      :rules="rule"
      ref="form"
    >
      <el-form-item prop="loginUserPwd" label="管理员密码">
        <el-input
          size="large"
          v-model="form.loginUserPwd"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item prop="pwd" label="修改用户密码">
        <el-input size="large" v-model="form.pwd" show-password></el-input>
      </el-form-item>
      <el-form-item prop="pwd2" label="确认密码">
        <el-input size="large" v-model="form.pwd2" show-password></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirmPwd">确 定</el-button>
      <el-button @click="showDialog = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Axios from "@/utils/Axios";
export default {
  name: "editPassword",
  props: {
    pwdDialog: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showDialog: {
      get: function () {
        return this.pwdDialog;
      },
      set: function (newValue) {
        this.$emit("update:pwdDialog", newValue);
      },
    },
  },
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.pwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      form: {
        loginUserPwd: "",
        pwd: "",
        pwd2: "",
      },
      rule: {
        loginUserPwd: [
          {
            required: true,
            trigger: "blur",
            message: "请输入管理员密码！",
          },
        ],
        pwd: [
          {
            min: 6,
            max: 16,
            required: true,
            trigger: "blur",
            message: "新密码长度必须在6~16位！",
          },
        ],
        pwd2: [{ validator: validatePass, required: true, trigger: "blur" }],
      },
      id: "",
    };
  },
  methods: {
    confirmPwd() {
      this.$refs.form.validate((val) => {
        if (val) {
          Axios.ajax({
            url: "/user/updatePwd",
            method: "post",
            data: {
              loginUserPwd: this.$md5(this.form.loginUserPwd),
              newPwd: this.$md5(this.form.pwd),
              userId: this.id,
            },
          }).then((res) => {
            if (res.resultCode == 0) {
              this.showDialog = false;
              this.$message.success("修改密码成功！");
            } else {
              this.$message.warning(res.resultMessage);
            }
          });
        }
      });
    },
    getId(id) {
      this.id = id;
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.pwdDialog {
  &__form {
    padding: 0 30px;
    .el-form-item:last-child {
      margin-bottom: 0px;
    }
  }
  .el-dialog {
    .el-dialog__body {
      padding-bottom: 0px !important;
    }
  }
}
</style>
